<template>
  <!-- <div> -->
  <div ref="charta2" style="width: 368px; height: 203px"></div>
  <!-- </div> -->
</template>

<script>
const echarts = require("echarts");
export default {
  components: {
    // Seacher,
  },
  data() {
    return {
      value: "",
    };
  },
  mounted() {
    // this.getchartsdata();
    this.initChartsa2();
  },
  destroyed() {},
  methods: {
    initChartsa2() {
      this.lineChart = echarts.init(this.$refs.charta2);
      let option = {
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: "9%",
          left: "3%",
          right: "4%",
          bottom: "8%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          show: true,
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          axisLine: {
            show: false, //隐藏x轴线
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false, //隐藏x轴刻度
          },
        },
        yAxis: {
          type: "value",
          show: true,
          axisLine: {
            show: false,
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            type: "line",
            smooth: true, //是否平滑
            symbol: "circle",
            smooth: true, // 线条是否平滑
            showSymbol: false,
            symbolSize: 10,
            lineStyle: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: "#00E79A",
                },
                {
                  offset: 0,
                  color: "#00E79A",
                },
              ]), //线条渐变色
              shadowOffsetX: 1, // 折线的X偏移
              shadowOffsetY: 9, // 折线的Y偏移
              shadowBlur: 8, // 折线模糊
              shadowColor: "rgba(146, 169, 255, 100)", //折线颜色
            },
            itemStyle: {
              color: "#000",
              borderColor: "#00E79A",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            data: [8232, 932, 9231, 3234, 19230, 12330, 12320],
          },
        ],
      };
      this.lineChart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped></style>
